import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { TabView } from "iuvity-ui-components/dist/tabview";
import { FormSkeleton } from "../../components";
import { AppContext } from "../../context/index";
import { useServices } from "../../hooks/useServices";
import { useSchedules } from "../../hooks/useSchedules";
import { useMasters } from "../../hooks/useMasters";
import { DataTable } from "iuvity-ui-components/dist/datatable";
import { Column } from 'primereact/column'
import { InputText } from "primereact/inputtext";
import { TableHeader } from "../../components/datatable/TableHeader";
import { servicesFields, schedulesFields, mastersFields, SCHEDULE_DAYS } from "../../constants";
import { FilterMatchMode } from "primereact/api";
import { Actions } from "../../components/datatable/Actions";
import { CustomDialog, DialogProps } from "../../components/dialog/CustomDialog";
import { SubheaderActions } from "iuvity-ui-components/dist/subheaderactions";
import { Button, TreeSelection } from "iuvity-ui-components";
import { SelectButton } from 'primereact/selectbutton';
import PerfectScrollbar from 'react-perfect-scrollbar';

import 'react-perfect-scrollbar/dist/css/styles.css';
import { formatHour12 } from "../../helpers/formatDate";
import { Controller, useForm } from "react-hook-form";
import { AdminSearchPointsPage } from "../../components/points/AdminSearchPointsPage";
import { UploadAndDownloadPage } from "./UploadAndDownloadPage";
import { subheaderActionsPrivilegeValidator } from "../../helpers/subheaderActionsPrivilegeValidator";
import { PrivilegeValidatorComponent } from "../../components/shared/PrivilegeValidatorComponent";
import jp from "jsonpath";

const filterDefaultValuesServices = {
    name: '',
    code: '',
    pointServiceType: '',
    description: '',
};

const filterDefaultValuesMasters = {
    code: '',
    name: '',
    description: '',
    layerImage: '',
    layerName: '',
};

export const AdminPointsPage = () => {
    sessionStorage.removeItem('LI::CONTROLLER');
    const navigate = useNavigate();
    const {
        t,
        appState: { language, activeIndexPoints, pageFilter, permissiondInfoByRole, infoObjRolesByTenantState: {
            dataRolesByTenantGlobal,
            functionalitiesCodesMap,
          } },
        setAppState,
    } = useContext(AppContext);

    const form = useForm({
        mode: "onChange",
        delayError: 1200,
        reValidateMode: "onChange",
        defaultValues: pageFilter
          ? activeIndexPoints === '5' ? {
                name: pageFilter?.functionality || [],
                code: pageFilter?.code || '',
                description: pageFilter?.description || '',
                layerImage: pageFilter?.layerImageLabel || '',
                layerName: pageFilter?.layerNameLabel || '',
                
              } : {
                name: pageFilter?.functionality || [],
                code: pageFilter?.code || '',
                pointServiceType: pageFilter?.ibmessage || '',
                description: pageFilter?.description || '',
            }
          : activeIndexPoints === '5' ? filterDefaultValuesMasters : filterDefaultValuesServices,
    });

    const [activeIndex, setActiveIndex] = useState<number>(activeIndexPoints || 0);
    const { dataService, serviceAction, reloadFnService } = useServices("DATA");
    const { dataSchedule, scheduleAction, reloadFnSchedule } = useSchedules("DATA");
    const { dataScheduleTypes } = useSchedules("TYPES");
    const { dataMaster, masterAction, reloadFnMaster } = useMasters("DATA");
    const pointsFeatures = ['administration', 'manage_files', 'services', 'schedules', 'masters']
    const [selectType, setSelectType] = useState("");
    const [selectDay, setSelectDay] = useState("");
    const [selectHour, setSelectHour] = useState("");
    const [isSelected, setIsSelected] = useState({
        EXTENDED: "",
        REGULAR: "",
        HOLIDAY: "",
        INTERMITTENT: "",
    });
    const [filteredDataDays, setFilteredDataDays] = useState<any | null>(null);
    const [filteredDataHours, setFilteredDataHours] = useState<any | null>(null);
    const [configDataSchedule, setConfigDataSchedule] = useState<any | null>(null);
    const objTypes = {
        EXTENDED: "",
        REGULAR: "",
        HOLIDAY: "",
        INTERMITTENT: "",
    }

    useEffect(()=>{
        // Lógica para obtener los privilegios según TabView
        setAppState((prev)=>({
            ...prev,
            functionalityCode: `/pointsofattention/${pointsFeatures[activeIndexPoints]}`
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[activeIndexPoints]);

    const [modalProps, setModalProps] = useState<DialogProps>({
        visible: false,
    } as DialogProps);

    const { control, setValue } = form;

    const [selectedColumns, setSelectedColumns] = useState<any>([]);
    const columns:any = useMemo(() => {
        if (language) {
            let columnsActive: any;
            switch (activeIndex) {
                case 2:
                    columnsActive=servicesFields(t)
                    break;
                case 3:
                    columnsActive=schedulesFields(t)
                    break;
                case 4:
                    columnsActive=mastersFields(t)
                    break;
                default:
                    columnsActive=[]
                    break;
            }
            setSelectedColumns(columnsActive)
            return columnsActive
        } else {
            return [];
        }
    }, [language, activeIndex, t]);

    const [servicesFilters, setServicesFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        pointServiceType: { value: null, matchMode: FilterMatchMode.CONTAINS },
        description: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const [mastersFilters, setMastersFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        description: { value: null, matchMode: FilterMatchMode.CONTAINS },
        layerImage: { value: null, matchMode: FilterMatchMode.CONTAINS },
        layerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const onEditAction = (configDataSelected: any) => {
        setAppState((prev) => ({
            ...prev,
            selectedPointsObject: configDataSelected,
        }));
        switch (activeIndex) {
            case 2:
                navigate("/pointsofattention/editservice");
                break;
            case 3:
                navigate("/pointsofattention/editschedule");
                break;
            case 4:
                navigate("/pointsofattention/editmaster");
                break;
            default:
                break;
        }
    };

    const onDeleteAction = async (configDataSelected: any) => {
        switch (activeIndex) {
            case 2:
                await serviceAction("DELETE", configDataSelected.id);
                reloadFnService();
                break;
            case 3:
                await scheduleAction("DELETE", configDataSelected.id);
                reloadFnSchedule();
                setSelectType('');
                setIsSelected(objTypes)
                setSelectDay('')
                setFilteredDataDays(null);
                setFilteredDataHours(null)
                break;
            case 4:
                await masterAction("DELETE", configDataSelected.id);
                reloadFnMaster();
                break;
        
            default:
                break;
        }
    };

    const handleModalProps = async (configDataSelected: any) => {
        switch (activeIndex) {
            case 2:
                setModalProps((prev) => ({
                    ...prev,
                    visible: true,
                    title: t("PointsOfAttention.deleteModalServiceTitle"),
                    content: `${t("PointsOfAttention.deleteModalServiceContent1Label")} "${configDataSelected?.name}" ${t(
                    "PointsOfAttention.deleteModalServiceContent2Label"
                    )}`,
                    onConfirm: () => onDeleteAction(configDataSelected),
                }));
                break;
            case 3:
                setModalProps((prev) => ({
                    ...prev,
                    visible: true,
                    title: t("PointsOfAttention.deleteModalScheduleTitle"),
                    content: `${t("PointsOfAttention.deleteModalScheduleContent1Label")} "${formatHour12(configDataSelected?.scheduleTimes[0]?.start)} - ${formatHour12(configDataSelected?.scheduleTimes[0]?.end)}" ${t(
                    "PointsOfAttention.deleteModalScheduleContent2Label"
                    )}`,
                    onConfirm: () => onDeleteAction(configDataSelected),
                }));
                break;
            case 4:
                setModalProps((prev) => ({
                    ...prev,
                    visible: true,
                    title: t("PointsOfAttention.deleteModalMasterTitle"),
                    content: `${t("PointsOfAttention.deleteModalMasterContent1Label")} "${configDataSelected?.name}" ${t(
                    "PointsOfAttention.deleteModalMasterContent2Label"
                    )}`,
                        onConfirm: () => onDeleteAction(configDataSelected),
                    }));
                break;
        }
    };

    const justifyTemplate = (option: any) => {
        return <span className="p-select-card-label">{option?.name ? option?.name : option}</span>;
    }

    useEffect(() => {
        if (selectType) {
            const days = dataSchedule
                ?.map((item: any) => item.scheduleTypeId === selectType && item.day )
                ?.filter((item: any) => item !== false)
            const orderData = language === 'en' 
                ?
                    Object.values(SCHEDULE_DAYS)?.flatMap((day) => (
                        days?.filter((item: any) => item.toUpperCase() === day && item)
                    ))
                : 
                    Object.keys(SCHEDULE_DAYS)?.flatMap((day) => (
                        days?.filter((item: any) => item === day && item)
                    ))
            setFilteredDataDays([...new Set(orderData)]);
        }
        if (selectDay) {
            const data = dataSchedule?.filter((item: any) => item.scheduleTypeId === selectType && item.day === selectDay)
            const hours = data?.flatMap((item: any) => {
                return item.scheduleTimes;
            })?.map((item: any) => {
                return {
                    name: `${formatHour12(item.start)} - ${formatHour12(item.end)}`,
                    value: `${item.id}`,
                    className: 'selectButtonColor'
                };
            })
            setFilteredDataHours(hours);
        }
        if (selectHour) {
            const data = dataSchedule?.filter((item: any) => item.scheduleTypeId === selectType && item.day === selectDay)
            const hour = data?.flatMap((item: any) => {
              return item.scheduleTimes;
            })?.find((item: any) => item.id === +selectHour)
            const res = dataSchedule?.filter((item: any) => item.id === hour?.scheduleDayId)
            setConfigDataSchedule(res?.[0])
        }
    }, [dataSchedule, selectType, selectDay, selectHour, language]);

    const handleChangeSelectScheduleType = (e: any) => {
        if (e?.node?.id === selectType) {
            setIsSelected(objTypes)
            setSelectType('')

            setFilteredDataDays(null)
            setSelectDay('')
            setFilteredDataHours(null)
            setSelectHour('')
        } else {
            setSelectType(e?.node?.id)
            const obj = Object.defineProperty(objTypes, e.node.label, {value: 'selected'})
            setIsSelected(obj)
        }
    }

    const handleChangeSelectDay = (e: any) => {
        if (e?.value === null) {
            setSelectDay('')
            setFilteredDataHours(null)
            setSelectHour('')
        } else {
            setSelectDay(e?.value)
            setSelectHour('')
        }
    }

    useEffect(() => {
        const handleSetActivewIndexEvent = ((
            event: CustomEvent<number>
        ) => {
            setActiveIndex(event.detail)
        }) as EventListener;
        window.addEventListener("POINTS::SET::TABVIEW", handleSetActivewIndexEvent);
        return () =>
            window.removeEventListener(
            "POINTS::SET::TABVIEW",
            handleSetActivewIndexEvent
            );
      }, []);

    const onClearFilters = (type: string) => {
        if (type === '3') {
            setServicesFilters({
              global: { value: null, matchMode: FilterMatchMode.CONTAINS },
              name: { value: null, matchMode: FilterMatchMode.CONTAINS },
              code: { value: null, matchMode: FilterMatchMode.CONTAINS },
              pointServiceType: { value: null, matchMode: FilterMatchMode.CONTAINS },
              description: { value: null, matchMode: FilterMatchMode.CONTAINS },
            });
            setAppState((prev) => ({
              ...prev,
              pageFilter: null,
            }));
            form.reset(filterDefaultValuesServices);
        }
        if (type === '5') {
            setMastersFilters({
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                code: { value: null, matchMode: FilterMatchMode.CONTAINS },
                name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                description: { value: null, matchMode: FilterMatchMode.CONTAINS },
                layerImage: { value: null, matchMode: FilterMatchMode.CONTAINS },
                layerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            });
            setAppState((prev) => ({
              ...prev,
              pageFilter: null,
            }));
            form.reset(filterDefaultValuesMasters);
        }
    };

    const filterTemplate = (options: any) => {
        return (
          <Controller
              name={options.field}
              control={control}
              render={({ field }) => {
                field.onChange = (e) => {
                  setValue(field.name, e.target.value);
                  options.filterCallback(e.target.value);
                };
                return (
                  <>
                    <label htmlFor={options.field} className="block lb mt-2 mb-2">
                      {t(`PointsOfAttention.${options.field}Label`)}
                    </label>
                    <InputText
                      placeholder={t(`PointsOfAttention.${options.field}Placeholder`)} 
                      autoComplete="off"
                      type={'text'}
                      className="mb-2"
                      {...field}
                    />
                  </>
                );
              }}
          />
        )
    }
    
    const filterClearTemplate = (options: any) => {
        return (
          <Button
            label={t("ValidationMessages.clearFilterLabel")}
            variant="p-button-text"
            onClick={() => onClearFilters(options)}
          />
        )
    }
      
    const filterApplyTemplate = (options: any) => {
        return (
          <Button
            label={t("ValidationMessages.applyFilterLabel")}
            className="p-button"
            onClick={options.filterApplyCallback}
          />
        )
    }

    const showTabViewController = (servicePointView: any[]) => {
        let showTabViewIndexes:any = [];
        if (!!dataRolesByTenantGlobal && !!functionalitiesCodesMap) {
                jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/pointsofattention/administration']}")].permission.privilegeId`).includes('READ') && showTabViewIndexes.push('1');
                jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/pointsofattention/manage_files']}")].permission.privilegeId`).includes('READ') && showTabViewIndexes.push('2');
                jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/pointsofattention/services']}")].permission.privilegeId`).includes('READ') && showTabViewIndexes.push('3');
                jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/pointsofattention/schedules']}")].permission.privilegeId`).includes('READ') && showTabViewIndexes.push('4');
                jp.query(dataRolesByTenantGlobal, `$..[?(@.functionalityId=="${functionalitiesCodesMap['/pointsofattention/masters']}")].permission.privilegeId`).includes('READ') && showTabViewIndexes.push('5');

                setTimeout(()=>{
                    if (!sessionStorage.getItem('LI::CONTROLLER')) {
                        sessionStorage.setItem('LI::CONTROLLER', 'load');
                        const tabview = document.getElementById('service-points-tabview');
                        const ulElem = tabview?.querySelector("ul");
                        if (ulElem && ulElem.children.length > 1) {
                            // eslint-disable-next-line array-callback-return
                            [...ulElem.children].map((_, index) => {
                                !showTabViewIndexes.includes((index+1).toString()) && (() => {
                                    // @ts-ignore
                                    ulElem.children[index].style.display = "none";})()
                            });
                        }
                    }
                },100);

                return servicePointView.map((tabViewItem) => showTabViewIndexes.includes(tabViewItem.key)
                    ? tabViewItem
                    : {
                        header: undefined,
                    });
            };
    };

    return (
        <>
            <TransactionalSubheader
                subheaderTitle={
                <div
                    style={{
                    position: "relative",
                    left: "-3rem",
                    }}
                >
                    {
                        t("PointsOfAttention.pointsTitle")
                    }
                </div>
                }
            >
                <TransactionalSubheader.BreadCrumb
                id={t("PointsOfAttention.pointsTitle")}
                disabledDefaultHome={true}
                breadcrumbsHomeItem={{
                    icon: "iu iu-icon-home",
                    command: () => navigate("/"),
                }}
                breadcrumbsItems={[
                    {
                        label: t("PointsOfAttention.pointsTitle"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                ]}
                />
                <TransactionalSubheader.Title />
            </TransactionalSubheader>

            <BoxFull className="my-4 px-0 py-0" variant="tertiary">
                <TabView
                    id='service-points-tabview'
                    className="upload-tabview mt-4"
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                        setAppState((prev) => ({
                            ...prev,
                            activeIndexPoints: e.index,
                        }));
                        setSelectType('');
                        setIsSelected(objTypes)
                        setSelectDay('')
                        setFilteredDataDays(null);
                        setFilteredDataHours(null);
                        setAppState((prev)=>({
                            ...prev,
                            functionalityCode: `/pointsofattention/${pointsFeatures[e.index]}`
                        }));
                    }}
                    items={showTabViewController([
                        {
                            key: "1",
                            header: t("PointsOfAttention.administrationTabTitle"),
                            children: <AdminSearchPointsPage />,
                            disabled: false,
                        },
                        {
                            key: "2",
                            header: t("PointsOfAttention.manage_filesTabTitle"),
                            children: <UploadAndDownloadPage />,
                        },
                        {
                            key: "3",
                            header: t("PointsOfAttention.servicesTabTitle"),
                            children: (
                                <>
                                    <div className="points__tabdescription">
                                        <span>{t("PointsOfAttention.servicesDescription")}</span>
                                    </div>

                                    <BoxFull className="ml-0 mt-0 mx-0 px-0" variant="tertiary">
                                        <div className="tablefilter-mc2">
                                            <Button
                                            className="hover"
                                            label={t("Tenants.clearFilterBtnLabel")}
                                            variant="p-button"
                                            icon="iu iu-icon-error"
                                            onClick={() => onClearFilters('3')}
                                            />
                                            <SubheaderActions
                                                className="my-0 mx-0 px-0 py-0"
                                                actions={subheaderActionsPrivilegeValidator([
                                                {
                                                    id: "333",
                                                    icon: "iu iu-icon-plus",
                                                    label: t("PointsOfAttention.newServiceBtnLabel"),
                                                    style: {
                                                        display: !permissiondInfoByRole.CREATE ? 'none' : undefined,
                                                      },
                                                    onClick: () => navigate('/pointsofattention/newservice'),
                                                },
                                                ])}
                                            />
                                        </div>
                                    </BoxFull>
                                
                                    <BoxFull className="dt-c px-0 py-0 mx-0" variant="tertiary">
                                        {dataService ? (
                                        <DataTable
                                            header={
                                                <TableHeader
                                                    title={t("PointsOfAttention.configTypeServicesTitle")}
                                                    columns={columns}
                                                    selectedColumns={selectedColumns}
                                                    toggleColumns={setSelectedColumns}
                                                    filters={servicesFilters}
                                                    setFilters={setServicesFilters}
                                                    reload={reloadFnService}
                                            />
                                            }
                                            currentPageReportTemplate={t(
                                                "ConsoleTranslations.rowsPaginatorTemplateLabel"
                                            )}
                                            paginatorRight={t('ConsoleTranslations.itemsTextDatatableLabel')}
                                            emptyMessage={t("TableActions.emptyMessage")}
                                            rows={10}
                                            size="normal"
                                            filters={servicesFilters}
                                            sortField="id"
                                            dataKey="id"
                                            sortOrder={1}
                                            value={dataService.map((configDataSelected: any) => ({
                                            ...configDataSelected,
                                            pointServiceType: configDataSelected?.pointServiceType?.name,
                                            actions: (
                                                <Actions
                                                    enableDelete={true}
                                                    onEdit={() => onEditAction(configDataSelected)}
                                                    onDelete={() => handleModalProps(configDataSelected)}
                                                    visibleObject={{...permissiondInfoByRole}}
                                                />
                                            ),
                                            }))}
                                            scrollable
                                            resizableColumns
                                            globalFilterFields={['name', 'code', 'pointServiceType', 'description']}
                                            filterDisplay="menu"
                                        >
                                            {selectedColumns.map((col:any) => {
                                            return (
                                                <Column
                                                    key={col.field}
                                                    field={col.field}
                                                    header={col.header}
                                                    sortable={!(col.field === "actions")}
                                                    align={
                                                        col.field === "actions" ? "center" : "left"
                                                    }
                                                    headerStyle={col.field === "actions"
                                                        ? {
                                                            justifyContent: "center",
                                                            display: (!permissiondInfoByRole.UPDATE && !permissiondInfoByRole.REMOVE) ? 'none' : undefined,
                                                          }
                                                        : undefined }
                                                    style={{
                                                        boxShadow: (col.field === "actions")
                                                        ? "rgb(230 230 230 / 55%) -2px 0px, rgb(235 235 235 / 55%) -3px 0px, rgb(240 240 240 / 45%) -5px 0px"
                                                        : undefined,
                                                        maxWidth: (col.field === "actions") ? "132px" : undefined,
                                                        whiteSpace: "normal",
                                                        display: (col.field === "actions")
                                                            ? ((!permissiondInfoByRole.UPDATE && !permissiondInfoByRole.REMOVE) ? 'none' : undefined)
                                                            : undefined,
                                                    }}
                                                    frozen={col.field === "actions" ? true : false}
                                                    alignFrozen={col.field === "actions" ? "right" : undefined}
                                                    filterField={col.field}
                                                    showFilterMatchModes={false}
                                                    filterMenuStyle={{ width: '23rem'}}
                                                    filter={col.field === "actions" ? false : true}
                                                    filterElement={filterTemplate}
                                                    filterApply={filterApplyTemplate}
                                                    filterClear={() => filterClearTemplate('3')}
                                                />
                                            );
                                            })}
                                        </DataTable>
                                        ) : (
                                        <FormSkeleton length={8} />
                                        )}
                                    </BoxFull>
                                </>
                            ),
                            disabled: false,
                        },
                        {
                            key: "4",
                            header: t("PointsOfAttention.schedulesTabTitle"),
                            children: (
                                <>
                                    <div className="points__tabdescription">
                                        <span>{t("PointsOfAttention.schedulesDescription")}</span>
                                    </div>
                                    <SubheaderActions
                                        className="mb-4 px-0"
                                        actions={subheaderActionsPrivilegeValidator([
                                        {
                                            id: "444",
                                            icon: "iu iu-icon-plus",
                                            label: t("PointsOfAttention.newScheduleBtnLabel"),
                                            style: {
                                                display: !permissiondInfoByRole.CREATE ? 'none' : undefined,
                                              },
                                            // onClick: () => setVisible(true),
                                            onClick: () => navigate('/pointsofattention/newschedule'),
                                        },
                                        ])}
                                    />
                                    <div className={`container-treeboxes mt-5`} id='PreparationFormContainer'>
                                        <div className={`treeboxes-child general-form start`}>
                                            <div className="treeboxes-title">
                                                <h2>{t('PointsOfAttention.typeOfScheduleLabel')}</h2>
                                            </div>
                                            <div className="treeboxes-item treeboxes-item__gray" style={{ height: '80%' }} id='SelectScheduleContainer'>
                                                <p className="points-subtitle">{t("PointsOfAttention.typeOfScheduleSubtitle")}</p>
                                                <TreeSelection
                                                    id='TransferTypesContainer'
                                                    children={<></>}
                                                    value={dataScheduleTypes?.map((item: any) => {
                                                        return {
                                                            id: item.id,
                                                            label: item.name,
                                                            // @ts-ignore
                                                            className: `schedule-card-${isSelected[item.name]}`
                                                        }
                                                    })}
                                                    selectionMode='single'
                                                    selectionKeys={selectType}
                                                    onSelect={(e: any) => handleChangeSelectScheduleType(e)}
                                                    style={{ margin: '0 auto'}}
                                                    className='col-8'
                                                />
                                            </div>
                                        </div>
                                        <div className={`treeboxes-child general-form mid`}>
                                            <div className="treeboxes-title">
                                                <h2>{t('PointsOfAttention.dayLabel')}</h2>
                                            </div>
                                            <div className="treeboxes-item tabletsecond treeboxes-item__white" style={{ height: '80%' }} id='SelectScheduleContainer'>
                                                <p className="points-subtitle">{t("PointsOfAttention.daySubtitle")}</p>
                                                <PerfectScrollbar>
                                                    <SelectButton
                                                        value={selectDay} 
                                                        options={filteredDataDays} 
                                                        onChange={(e) => handleChangeSelectDay(e)}
                                                        itemTemplate={justifyTemplate}
                                                    />
                                                </PerfectScrollbar>
                                            </div>
                                        </div>
                                        <div className={`treeboxes-child general-form end`}>
                                            <div className="treeboxes-title">
                                                <h2>{t('PointsOfAttention.hourLabel')}</h2>
                                            </div>
                                            <div className="treeboxes-item tabletsecond treeboxes-item__gray" style={{ height: '80%' }} id='SelectScheduleContainer'>
                                                <p className="points-subtitle">{t("PointsOfAttention.hourSubtitle")}</p>
                                                <PerfectScrollbar>
                                                    <SelectButton
                                                        value={selectHour} 
                                                        options={filteredDataHours} 
                                                        onChange={(e) => setSelectHour(e.value)}
                                                        itemTemplate={justifyTemplate}
                                                    />
                                                </PerfectScrollbar>
                                            </div>
                                        </div>
                                    </div>
                                    <BoxFull className="my-5 mr-0 p-0" style={{ backgroundColor: "transparent" }}>
                                        <div className="flex align-items-center justify-content-end gap-5">
                                        <PrivilegeValidatorComponent showButton={permissiondInfoByRole.REMOVE} >
                                            <Button
                                                variant="p-button-link"
                                                label={t("PointsOfAttention.deleteBtnLabel")}
                                                disabled={(selectType && selectDay && selectHour) ? false : true}
                                                onClick={() => handleModalProps(configDataSchedule)}
                                            />
                                        </PrivilegeValidatorComponent>
                                        <PrivilegeValidatorComponent showButton={permissiondInfoByRole.UPDATE} >
                                            <Button
                                                variant="p-button"
                                                label={t("PointsOfAttention.editBtnLabel")}
                                                disabled={(selectType && selectDay && selectHour) ? false : true}
                                                onClick={() => onEditAction(configDataSchedule)}
                                            />
                                        </PrivilegeValidatorComponent>
                                        </div>
                                    </BoxFull>
                                </>
                            ),
                            disabled: false,
                        },
                        {
                            key: "5",
                            header: t("PointsOfAttention.mastersTabTitle"),
                            children: (
                                <>
                                    <div className="points__tabdescription">
                                        <span>{t("PointsOfAttention.mastersDescription")}</span>
                                    </div>
                                    <BoxFull className="ml-0 mt-0 mx-0 px-0" variant="tertiary">
                                        <div className="tablefilter-mc2">
                                            <Button
                                            className="hover"
                                            label={t("Tenants.clearFilterBtnLabel")}
                                            variant="p-button"
                                            icon="iu iu-icon-error"
                                            onClick={() => onClearFilters('5')}
                                            />
                                            <SubheaderActions
                                                className="my-0 mx-0 px-0 py-0"
                                                actions={subheaderActionsPrivilegeValidator([
                                                    {
                                                        id: "555",
                                                        icon: "iu iu-icon-plus",
                                                        label: t("PointsOfAttention.newMasterBtnLabel"),
                                                        style: {
                                                            display: !permissiondInfoByRole.CREATE ? 'none' : undefined,
                                                          },
                                                        onClick: () => navigate('/pointsofattention/newmaster'),
                                                    },
                                                ])}
                                            />
                                        </div>
                                    </BoxFull>
                                    
                                    <BoxFull className="dt-c px-0 py-0 mx-0" variant="tertiary">
                                        {dataMaster ? (
                                        <DataTable
                                            header={
                                                <TableHeader
                                                    title={t("PointsOfAttention.configTypeMastersTitle")}
                                                    columns={columns}
                                                    selectedColumns={selectedColumns}
                                                    toggleColumns={setSelectedColumns}
                                                    filters={mastersFilters}
                                                    setFilters={setMastersFilters}
                                                    reload={reloadFnSchedule}
                                            />
                                            }
                                            currentPageReportTemplate={t(
                                                "ConsoleTranslations.rowsPaginatorTemplateLabel"
                                            )}
                                            paginatorRight={t('ConsoleTranslations.itemsTextDatatableLabel')}
                                            emptyMessage={t("TableActions.emptyMessage")}
                                            rows={10}
                                            size="normal"
                                            filters={mastersFilters}
                                            sortField="id"
                                            dataKey="id"
                                            sortOrder={1}
                                            value={dataMaster.map((configDataSelected: any) => ({
                                            ...configDataSelected,
                                            layerName: configDataSelected?.image?.layerName,
                                            actions: (
                                                <Actions
                                                    enableDelete={true}
                                                    onEdit={() => onEditAction(configDataSelected)}
                                                    onDelete={() => handleModalProps(configDataSelected)}
                                                    visibleObject={{...permissiondInfoByRole}}
                                                />
                                            ),
                                            }))}
                                            scrollable
                                            resizableColumns
                                            globalFilterFields={['code', 'name', 'description', 'layerImage', 'layerName']}
                                            filterDisplay="menu"
                                        >
                                            {selectedColumns.map((col:any) => {
                                            return (
                                                <Column
                                                    key={col.field}
                                                    field={col.field}
                                                    header={col.header}
                                                    sortable={!(col.field === "actions")}
                                                    align={
                                                        col.field === "actions" ? "center" : "left"
                                                    }
                                                    headerStyle={col.field === "actions"
                                                        ? {
                                                            justifyContent: "center",
                                                            display: (!permissiondInfoByRole.UPDATE && !permissiondInfoByRole.REMOVE) ? 'none' : undefined,
                                                        }
                                                        : undefined }
                                                    style={{
                                                        boxShadow: (col.field === "actions")
                                                        ? "rgb(230 230 230 / 55%) -2px 0px, rgb(235 235 235 / 55%) -3px 0px, rgb(240 240 240 / 45%) -5px 0px"
                                                        : undefined,
                                                        maxWidth: (col.field === "actions") ? "132px" : undefined,
                                                        whiteSpace: "normal",
                                                        display: (col.field === "actions")
                                                            ? ((!permissiondInfoByRole.UPDATE && !permissiondInfoByRole.REMOVE) ? 'none' : undefined)
                                                            : undefined,
                                                    }}
                                                    frozen={col.field === "actions" ? true : false}
                                                    alignFrozen={col.field === "actions" ? "right" : undefined}
                                                    filterField={col.field}
                                                    showFilterMatchModes={false}
                                                    filterMenuStyle={{ width: '23rem'}}
                                                    filter={col.field === "actions" ? false : true}
                                                    filterElement={filterTemplate}
                                                    filterApply={filterApplyTemplate}
                                                    filterClear={() => filterClearTemplate('5')}
                                                />
                                            );
                                            })}
                                        </DataTable>
                                        ) : (
                                        <FormSkeleton length={8} />
                                        )}
                                    </BoxFull>
                                </>
                            ),
                            disabled: false,
                        },
                    ]) ?? []}
                />
            </BoxFull>
            <CustomDialog
                title={modalProps.title}
                visible={modalProps.visible}
                content={modalProps.content}
                handleModalState={setModalProps}
                onConfirm={modalProps.onConfirm}
            />
        </>
    )
}